<template>
  <div class="loader-deal-wrapper">
    <div class="loader-deal">
      <div class="loader-deal-header">
        <img src="../assets/img/cashback-icon.svg" alt="icon">
        <span>Your Cashback </span>
        is here
      </div>
      <div class="loader-deal-title">
        Thank you, <br> almost there...
      </div>
      <div class="loader-deal-action" v-lazy-container="{ selector: 'img'}">
        <img :data-src="icon" :data-error="imgPlaceholder()" alt="" class="loader-deal-logo">
        <svg height="96" width="96">
          <circle class="circle" cx="48" cy="48" r="42" stroke="#00C6A2" stroke-width="3" fill-opacity="0" />
        </svg>
      </div>
      <div class="loader-deal-footer">
        <span class="text-big">We are redirecting you</span>
        <span class="text-small">to complete your buying with {{title || 'Rakuten'}}</span>
        <img v-if="storeImage" :src="storeImage" :alt="title">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoaderDeal',
  data: function () {
    return {
      title: this.$route.query.title,
      url: this.$route.query.url,
      icon: this.$route.query.icon,
      storeImage: this.$route.query.storeImage,
      swagbucks_merchant_id: this.$route.query.swagbucks_merchant_id,
      swagbucks_network_code: this.$route.query.swagbucks_network_code,
      rakuten_merchant_id: this.$route.query.rakuten_merchant_id,
      type: this.$route.query.type,
      lcid: this.$route.query.lcid,
    }
  },
  mounted() {
      let redirectUrl = this.$route.query.url;
      const preventRedirect = this.swagbucks_network_code && this.swagbucks_network_code === 'CJ';
      const isLC = location.hostname.split('.')[0] === 'lc';
      const lcParam = this.lcid ? '&lcid=' + this.lcid : '';
      if (this.swagbucks_merchant_id && this.type === 'shop' && !preventRedirect) {
        if (isLC) {
          redirectUrl = `https://trackvrz.com/adServe/aff?oid=601441&pid=446588${lcParam}&dp2=https://www.swagbucks.com/cashback-redirect?merchant=${this.swagbucks_merchant_id}&cxid=${this.swagbucks_merchant_id}`;
        } else {
          redirectUrl = `https://trackvrz.com/adServe/aff?oid=589085&pid=443663&dp2=https://www.swagbucks.com/cashback-redirect?merchant=${this.swagbucks_merchant_id}&cxid=${this.swagbucks_merchant_id}`;
        }
      } else if (this.swagbucks_merchant_id && this.type === 'cashback') {
        if (isLC) {
            redirectUrl = `https://trackvrz.com/adServe/aff?oid=601739&pid=446588${lcParam}&dp2=https://www.swagbucks.com/shop/store/${this.swagbucks_merchant_id}?cxid=${this.swagbucks_merchant_id}&utm_term=mid${this.swagbucks_merchant_id}`
        } else  {
          redirectUrl = `https://trackvrz.com/adServe/aff?oid=589279&pid=443663&dp2=https://www.swagbucks.com/shop/store/${this.swagbucks_merchant_id}?cxid=${this.swagbucks_merchant_id}&utm_term=mid${this.swagbucks_merchant_id}`
        }
      } else if (this.rakuten_merchant_id && this.type === 'cashback') {
        if (isLC) {
          redirectUrl = `https://trackvrz.com/adServe/aff?oid=601740&pid=446588${lcParam}&dp2=https://www.rakuten.com/signup_sem_mobile.htm?merchant_id=${this.rakuten_merchant_id}`
        } else  {
          redirectUrl = `https://trackvrz.com/adServe/aff?oid=589087&pid=443663&dp2=https://www.rakuten.com/signup_sem_mobile.htm?merchant_id=${this.rakuten_merchant_id}`
        }
      }
    setTimeout(() => {
     window.location.href = redirectUrl;
    }, 3000)
  },
  methods: {
    imgPlaceholder() {
      return require('../assets/img/cashback-icon.svg');
    }
  }
}
</script>
<style lang="scss">
  .loader-deal {
    text-align: center;
    height: 100vh;
    max-height: 600px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;

    &-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #fff;
      position: fixed;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      z-index: 10;
    }

    &-title {
      font-weight: 500;
      font-size: 24px;
      line-height: 1.4;
    }

    &-action {
      background: #FFFFFF;
      border-radius: 1000px;
      position: relative;
      width: 136px;
      height: 136px;
      display: flex;
      align-items: center;
      justify-content: center;

      &:before,
      &:after {
        content: "";
        display: block;
        border-radius: 50%;
        background: #F8F8FC;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: -1;
        animation: pulse 2s infinite;
      }

      &:before {
        opacity: 0.8;
        width: 100%;
        height: 100%;
      }

      &:after {
        opacity: 0.4;
        width: 200%;
        height: 200%;
      }
    }

    &-header {
      font-size: 14px;
      display: flex;
      align-items: center;

      img {
        margin-right: 15px;
      }

      span {
        font-weight: 700;
        margin-right: 5px;
      }
    }

    &-footer {
      display: flex;
      flex-direction: column;
      align-items: center;
      line-height: 1.8;

      img {
        max-width: 85px;
        margin-top: 20px;
      }

      .text-big {
        font-size: 13px;
      }

      .text-small {
        font-size: 11px;
      }
    }

    &-logo {
      max-width: 55px;
      position: absolute;
    }
  }

  .circle {
    stroke-dasharray: 1000;
    stroke-dashoffset: 1000;
    animation: stroke 4s ease-out forwards;
  }

  @keyframes stroke {
    to {
      stroke-dashoffset: 0;
    }
  }

  @keyframes pulse {
    0% {
      -moz-box-shadow: 0 0 0 0 #F8F8FC;
      box-shadow: 0 0 0 0 #F8F8FC;
    }
    70% {
      -moz-box-shadow: 0 0 0 200px rgba(204,169,44, 0);
      box-shadow: 0 0 0 200px rgba(204,169,44, 0);
    }
    100% {
      -moz-box-shadow: 0 0 0 0 rgba(204,169,44, 0);
      box-shadow: 0 0 0 0 rgba(204,169,44, 0);
    }
  }
</style>
